export const baseURL = () => "https://api.aliviaapp.com.br"
// export const baseURL = () => "http://localhost:3001"


export const versionApp = "1.0.3"
// export const baseURL = () => "https://homologacao.aliviaapp.com.br"
